import React from 'react';
import isEqual from 'lodash/isEqual';
import { dataTableStyles, HeaderWrapper, HeaderRow } from '@creditflowresearch/uilib/Table/DataTable';
import { FieldArray, useFormState, FormSpy } from '@framework/ui/Organisms/FinalForm';
import TableWrapper from '@framework/ui/Molecules/Tables/TableWrapper';
import { PORTFOLIO_REVIEW_UNKNOWNS_FIELD_ARRAY } from './constants';
import { columns } from './columns';
import UnknownBondModal from './UnknownBondModal';
import FormBottomNavigation
  from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/FormBottomNavigation';
import {
  IOptionalDataFormState,
} from '@/creditflowresearch/ui/components/portfolioMonitor/interfaces';
import ReviewUnknownsFieldsList from './ReviewUnknownsFieldsList';
import ConfirmDeletePositionContextProvider
  from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/ConfirmDeletePositionContext/ConfirmDeletePositionContext';
import ConfirmDeletePositionModal
  from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/ConfirmDeletePositionContext/ConfirmDeletePositionModal';

import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

interface IProps {
  setIsAnyChanges: React.Dispatch<React.SetStateAction<boolean>>,
  cancelButtonClick: () => void,
}

const ReviewUnknownsFields = ({ setIsAnyChanges, cancelButtonClick }: IProps) => {
  const {
    hasValidationErrors,
    hasSubmitErrors,
    dirtySinceLastSubmit,
  } = useFormState<IOptionalDataFormState>();

  return (
    <>
      <FormSpy
        onChange={
        ({ dirty, values, initialValues }) => setIsAnyChanges(
            (prev) => prev || (dirty && !isEqual(initialValues, values)),
        )
      }
      />
      <TableWrapper className={ spaceStyles.pn }>
        <table className={ dataTableStyles.dataTable }>
          <HeaderWrapper>
            <HeaderRow columns={ columns } />
          </HeaderWrapper>
        </table>
        <FieldArray
          name={ PORTFOLIO_REVIEW_UNKNOWNS_FIELD_ARRAY }
          render={ ({ fields }) => (
            <ConfirmDeletePositionContextProvider fields={ fields }>
              <>
                <ConfirmDeletePositionModal />
                <ReviewUnknownsFieldsList />
              </>
            </ConfirmDeletePositionContextProvider>
          ) }
        />
        <FormBottomNavigation
          isSubmitDisabled={ hasValidationErrors || (hasSubmitErrors && !dirtySinceLastSubmit) }
          onCancelClick={ cancelButtonClick }
        />
      </TableWrapper>
      <UnknownBondModal />
    </>
  );
};

export default ReviewUnknownsFields;
